import { render, staticRenderFns } from "./SidebarSide.vue?vue&type=template&id=36bba08d&"
import script from "./SidebarSide.vue?vue&type=script&lang=js&"
export * from "./SidebarSide.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports